import { del, get, set } from "idb-keyval";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";

const CACHE_KEY = "agricos-monitor-query-cache";

const indexedDbStorage = {
  getItem: async (key: string) => (await get<string>(key)) ?? null,
  setItem: async (key: string, value: string) => {
    await set(key, value);
  },
  removeItem: async (key: string) => {
    await del(key);
  },
};

export const offlineQueryPersister = createAsyncStoragePersister({
  storage: indexedDbStorage,
  key: CACHE_KEY,
  throttleTime: 1_000,
});

// Persistimos sólo datos necesarios para una lectura offline útil. Se excluyen
// históricos grandes, administración, invitaciones y cualquier mutación.
const OFFLINE_QUERY_ROOTS = new Set([
  "userProfile",
  "userMemberships",
  "latest-sensor-readings",
  "latest-voltage-readings",
  "rain-stats",
  "daily-rollups",
  "station-locations",
  "alerts",
  "threshold_rules",
]);

const OFFLINE_TABLES = new Set([
  "stations",
  "groups",
  "devices",
  "sensors",
  "sensor_types",
  "measurement_units",
  "alerts",
  "threshold_rules",
  "actuators",
  "actuator_types",
]);

export function shouldPersistOfflineQuery(queryKey: readonly unknown[]) {
  const root = String(queryKey[0] ?? "");
  if (root === "tableData") {
    return OFFLINE_TABLES.has(String(queryKey[1] ?? ""));
  }
  return OFFLINE_QUERY_ROOTS.has(root);
}
